var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.921,
    height: 40.425,
    viewBox: "0 0 36.921 40.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_178",
    x: 0,
    y: 0,
    width: 36.921,
    height: 40.425,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb254",
    floodOpacity: 0.561
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_186",
    x: 24.679,
    y: 9.818,
    width: 10.078,
    height: 13.587,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb254",
    floodOpacity: 0.561
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_187",
    x: 3.71,
    y: 24.651,
    width: 10.087,
    height: 13.587,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb254",
    floodOpacity: 0.561
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_115",
    "data-name": "Groupe 115",
    transform: "translate(-775.495 -1774.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 775.5, 1774.5)",
    filter: "url(#Trac\\xE9_178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_178-2",
    "data-name": "Trac\\xE9 178",
    d: "M793.792,1774.5h14.124v27.539a.706.706,0,0,1-.66.386q-8.152-.009-16.3,0a2.771,2.771,0,0,1-1.872-.7l-.6-.519a.5.5,0,0,0-.055.081,1.674,1.674,0,0,1-1.734,1.138c-1.636-.01-3.272,0-4.908,0a1.646,1.646,0,0,1-1.788-1.777q0-4.308,0-8.616a1.643,1.643,0,0,1,1.77-1.768c1.563,0,3.127.014,4.69-.007a1.91,1.91,0,0,1,1.762.72c.709-.709,1.39-1.4,2.087-2.078a.5.5,0,0,0,.151-.567q-1.288-4.755-2.556-9.516c-.136-.506-.005-.732.5-.865q1.67-.446,3.34-.89c.557-.149,1.114-.3,1.676-.453,0-.473.016-.919-.005-1.363A.719.719,0,0,1,793.792,1774.5Zm8.915,4.047h-4.089a2.531,2.531,0,0,1-1.687,1.855.347.347,0,0,0-.277.405q.009,4.866,0,9.733v.3h2.9a2.613,2.613,0,1,1,2.819-4.342,2.506,2.506,0,0,1,.893,1.917,2.651,2.651,0,0,1-1.466,2.426,2.006,2.006,0,0,1,2.47,2.632l.394.032v-.352q0-2.781,0-5.562c0-.551.172-.812.539-.817s.552.256.552.829c0,2.117,0,4.235.005,6.352a1,1,0,0,0,.121.457,1.859,1.859,0,0,1-.869,2.616c-.079.035-.156.072-.239.11a1.84,1.84,0,0,1-.152,1.866,1.893,1.893,0,0,1-1.684.809,1.991,1.991,0,0,1,.015,1.5H806.8v-25.7H794.519v15.242h1.049v-.359q0-5.084,0-10.169c0-.1,0-.2,0-.3a.536.536,0,0,1,.546-.559,1.459,1.459,0,0,0,1.459-1.433.56.56,0,0,1,.641-.582q2.44,0,4.88,0a.56.56,0,0,1,.651.571,1.462,1.462,0,0,0,1.476,1.446.511.511,0,0,1,.523.519c.013.745.007,1.49,0,2.235a.493.493,0,0,1-.321.466.54.54,0,0,1-.757-.539c-.014-.481,0-.963-.011-1.445a.309.309,0,0,0-.141-.24A2.617,2.617,0,0,1,802.707,1778.547Zm-11.825,11.306c-.8.8-1.554,1.552-2.306,2.315a.382.382,0,0,0-.071.247q-.005,3.585,0,7.171a.489.489,0,0,0,.149.316c.332.309.69.591,1.022.9a1.951,1.951,0,0,0,1.411.532c3.244-.009,6.489,0,9.733,0,.155,0,.31.006.463,0a.762.762,0,1,0-.095-1.52c-1.336-.005-2.672,0-4.008,0-.4,0-.651-.208-.659-.533s.253-.556.662-.557q1.186,0,2.372,0,1.731,0,3.463,0a.772.772,0,0,0,.8-.526.764.764,0,0,0-.81-1q-2.9,0-5.807,0c-.419,0-.677-.2-.682-.537s.257-.553.693-.553h2.208c1.581,0,3.163,0,4.744,0a.792.792,0,0,0,.771-.413.755.755,0,0,0-.689-1.112c-.872-.011-1.745,0-2.617,0q-2.236,0-4.471,0a.565.565,0,0,1-.6-.37c-.141-.379.136-.721.592-.721q2.6,0,5.208,0c.6,0,.96-.28.967-.755s-.359-.772-.977-.772H791.991c-.446,0-.6-.121-.71-.55Zm-7.178,1.5c-.72,0-1.4-.008-2.081,0a.534.534,0,0,0-.535.6q0,4.389,0,8.778a.543.543,0,0,0,.591.6q2.576.006,5.152,0a.537.537,0,0,0,.579-.581q0-4.4,0-8.8a.545.545,0,0,0-.6-.59c-.382-.005-.763,0-1.145,0h-.871v.338q0,2.862,0,5.725a2.354,2.354,0,0,1-.005.272.543.543,0,0,1-1.081-.011,2.612,2.612,0,0,1,0-.272q0-2.862,0-5.725Zm5.341-12.447,3.223,11.937h1.085c-.03-.116-.053-.212-.079-.307q-1-3.692-1.992-7.384c-.136-.5-.041-.681.456-.869a1.473,1.473,0,0,0,.94-1.68c-.087-.453.032-.664.491-.774.207-.05.25-.145.245-.336-.012-.5,0-1,0-1.5,0-.077-.009-.153-.016-.253Zm11.628,11.076a1.521,1.521,0,1,0-1.53-1.519A1.535,1.535,0,0,0,800.672,1789.981Zm-7.31-3.3h.029v-4.291c-.28.236-.572.474-.852.724a.264.264,0,0,0-.076.215C792.758,1784.446,793.061,1785.562,793.362,1786.678Z",
    transform: "translate(-775.5 -1774.5)",
    fill: "#ffb254"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 775.5, 1774.5)",
    filter: "url(#Trac\\xE9_186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_186-2",
    "data-name": "Trac\\xE9 186",
    d: "M1119.935,1909.529a.544.544,0,1,1,.011,1.087.544.544,0,0,1-.011-1.087Z",
    transform: "translate(-1090.23 -1899.71)",
    fill: "#ffb254"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 775.5, 1774.5)",
    filter: "url(#Trac\\xE9_187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_187-2",
    "data-name": "Trac\\xE9 187",
    d: "M831.573,2113.527a.543.543,0,1,1-.546.527A.55.55,0,0,1,831.573,2113.527Z",
    transform: "translate(-822.82 -2088.88)",
    fill: "#ffb254"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.7177f3af3c3d8fd38793906a021c65e8.svg";
export { ForwardRef as ReactComponent };